import { useNavigate } from '@tanstack/react-router'
import { Activity, ArrowRight } from 'lucide-react'
import { useEffect, useState } from 'react'
import { useAuth } from '../../auth/AuthContext'

export function Navbar() {
    const { isAuthenticated } = useAuth()
    const navigate = useNavigate()
    const [scrolled, setScrolled] = useState(false)

    useEffect(() => {
        const handleScroll = () => {
            const isScrolled = window.scrollY > 20
            if (isScrolled !== scrolled) {
                setScrolled(isScrolled)
            }
        }

        window.addEventListener('scroll', handleScroll, { passive: true })
        return () => window.removeEventListener('scroll', handleScroll)
    }, [scrolled])

    const handleAuthAction = () => {
        if (isAuthenticated) {
            navigate({ to: '/home' })
        } else {
            navigate({ to: '/login', search: { redirect: '/' } })
        }
    }

    return (
        <nav
            className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 border-b ${
                scrolled
                    ? 'bg-white/90 dark:bg-slate-900/90 backdrop-blur-sm border-slate-200 dark:border-slate-800 py-3 shadow-sm'
                    : 'bg-transparent border-transparent py-6'
            }`}
        >
            <div className="max-w-7xl mx-auto px-6 flex justify-between items-center">
                <div
                    className="flex items-center gap-3 cursor-pointer group"
                    onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                >
                    <div className="relative w-10 h-10 flex items-center justify-center bg-[#005451] rounded-xl shadow-lg shadow-[#005451]/20 group-hover:scale-105 transition-transform duration-300">
                        <Activity className="text-white" size={20} strokeWidth={2.5} />
                        <div className="absolute inset-0 bg-white/20 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity" />
                    </div>
                    <span className="text-xl font-bold tracking-tight text-slate-900 dark:text-white group-hover:text-[#005451] dark:group-hover:text-[#00a8a1] transition-colors">
                        Options<span className="text-[#005451] dark:text-[#00a8a1]">Oracle</span>
                    </span>
                </div>

                <div className="hidden md:flex items-center gap-8 text-sm font-medium text-slate-600 dark:text-slate-400">
                    {['Features', 'Analytics', 'About'].map((item) => (
                        <a
                            key={item}
                            href={`#${item.toLowerCase()}`}
                            className="hover:text-[#005451] dark:hover:text-[#00a8a1] transition-colors hover:scale-105 transform"
                        >
                            {item}
                        </a>
                    ))}
                </div>

                <div className="flex items-center gap-4">
                    <button
                        onClick={handleAuthAction}
                        className="text-sm font-semibold text-slate-600 dark:text-slate-400 hover:text-[#005451] dark:hover:text-[#00a8a1] transition-colors hidden sm:block"
                    >
                        {isAuthenticated ? 'Dashboard' : 'Sign In'}
                    </button>
                    <button
                        onClick={handleAuthAction}
                        className="group relative px-5 py-2.5 bg-[#005451] text-white rounded-full text-sm font-bold shadow-lg shadow-[#005451]/20 hover:shadow-xl hover:shadow-[#005451]/30 hover:bg-[#004240] transition-all duration-300 hover:scale-105 active:scale-95 overflow-hidden"
                    >
                        <span className="relative z-10 flex items-center gap-2">
                            Get Started{' '}
                            <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
                        </span>
                    </button>
                </div>
            </div>
        </nav>
    )
}
